export const isTw =
  window.location.host.indexOf('pay-sausageman.starforce.tw') > -1;
